import { render } from "./NavRoot.vue?vue&type=template&id=6a398dc1&scoped=true&ts=true"
import script from "./NavRoot.vue?vue&type=script&lang=ts"
export * from "./NavRoot.vue?vue&type=script&lang=ts"

import "./NavRoot.vue?vue&type=style&index=0&id=6a398dc1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a398dc1"]])

export default __exports__